"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchContactByEmailAddress = exports.createFetchContactByEmailAddress = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _formatContactsByEmail = _interopRequireDefault(require("reference-resolvers/formatters/formatContactsByEmail"));

var BASE_URI = 'contacts/v1/contact';

var createFetchContactByEmailAddress = function createFetchContactByEmailAddress(_ref) {
  var httpClient = _ref.httpClient;
  return function (emailAddresses) {
    return Promise.all(emailAddresses.map(function (emailAddress) {
      return httpClient.get(BASE_URI + "/email/" + emailAddress + "/profile").then(function (contact) {
        return {
          emailAddress: emailAddress,
          contact: contact
        };
      }, function (error) {
        return {
          emailAddress: emailAddress,
          error: error
        };
      });
    })).then(_formatContactsByEmail.default);
  };
};

exports.createFetchContactByEmailAddress = createFetchContactByEmailAddress;
var fetchContactByEmailAddress = createFetchContactByEmailAddress({
  httpClient: _apiClient.default
});
exports.fetchContactByEmailAddress = fetchContactByEmailAddress;